import { Link } from "@/components/common/Link";
export default function PhotoCredit() {
  return <section data-section-id="157851" id="local-relevance-for-homestead" className="w-full bg-background text-foreground pt-8 pb-12">
      <div className="container mx-auto px-4 md:px-6">
        <p className="text-lg font-sans font-normal leading-relaxed text-foreground text-center">
          Providing Homestead with specialized inspections for South Florida's unique climate.{" "}
          <Link to="https://trusted-fl.com/#our-inspection-services" className="transition-colors duration-300 text-primary hover:text-secondary">
            View our local services
          </Link>
        </p>
      </div>
    </section>;
}